module.exports = __webpack_public_path__ + "static/media/ชวด.7db70e9c.jpg";